/**
 * Moved to `shared/src/review/section-gaps.ts` so the review surface and the server-side
 * export read one copy of this logic. Edit it there.
 *
 * Named rather than `export *`: the Vite dev server's CommonJS interop runs a
 * star re-export before the module it re-exports has loaded.
 */
export {
  hasSectionGapsForV2Row,
  isPageTitleHeading,
  sectionGapClosestHeading,
  sectionGapClosestPct,
  sectionGapGroupHeading,
  sectionGapGroupMembers,
  sectionGapHasCloseMatch,
  sectionGapLabel,
  sectionGapLevel,
  sectionGaps,
  sectionGapsForV2Row
} from '@taptimize/shared/dist/review/section-gaps';
export type {
  SectionGapMember
} from '@taptimize/shared/dist/review/section-gaps';
